import { useState, useEffect, useRef } from "react"

import Style from "./style"
import FranchiseModal from "./ui/FranchiseModal"
import pwHide from "./asset/pwHide.svg"
import pwShow from "./asset/pwShow.svg"
import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

import usePostManager from "entity/auth/usePostManager"
import usePostUtilSms from "entity/util/usePostUtilSms"
import usePostUtilSmsConfirm from "entity/util/usePostUtilSmsConfirm"

import DefaultButton from "shared/ui/DefaultButton"
import DefaultInput from "shared/ui/DefaultInput"
import useConfrimCookie from "shared/model/useConfrimCookie"
import { ROLE_STORE_MANAGER, ROLE_FRANCHISE_MANAGER } from "shared/constant/lookup/role"

const SignupManager = () => {
    const [isPwShow, setIsPwShow] = useState(false)
    const [roleFlag, setRoleflag] = useState(ROLE_FRANCHISE_MANAGER)
    const [isModalShow, setIsModalShow] = useState(false)
    const [franchiseData, setFranchiseData] = useState(null)

    const idRef = useRef()
    const pwRef = useRef()
    const nameRef = useRef()
    const contactRef = useRef()
    const confirmRef = useRef()

    const [sendState, sendEvent] = usePostUtilSms(contactRef)
    const [confirmEvent] = usePostUtilSmsConfirm(contactRef, confirmRef)
    const [postAdmin] = usePostManager(idRef, pwRef, nameRef, franchiseData, roleFlag)

    const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie()

    useEffect(() => {
        return () => {
            deleteConfirmCookie()
        }
    }, [])

    return (
        <>
            {isModalShow && <FranchiseModal closeEvent={() => setIsModalShow(false)} setFranchiseData={setFranchiseData} />}

            <Style.Wrapper>
                <Style.ContentDiv>
                    <h2>매니저 회원가입</h2>

                    <Style.RoleDiv>
                        <DefaultButton minor={roleFlag !== ROLE_FRANCHISE_MANAGER} clickEvent={() => setRoleflag(ROLE_FRANCHISE_MANAGER)}>
                            <Style.CheckIcon src={roleFlag !== ROLE_FRANCHISE_MANAGER ? check : checked} />
                            프렌차이즈 매니저
                        </DefaultButton>
                        <DefaultButton minor={roleFlag !== ROLE_STORE_MANAGER} clickEvent={() => setRoleflag(ROLE_STORE_MANAGER)}>
                            <Style.CheckIcon src={roleFlag !== ROLE_STORE_MANAGER ? check : checked} />
                            매장 매니저
                        </DefaultButton>
                    </Style.RoleDiv>

                    <Style.FormDiv>

                        {roleFlag === ROLE_STORE_MANAGER &&
                            <Style.FranchiseDiv>
                                <Style.FranchiseTitle>
                                    <h2>프렌차이즈 선택<span>*</span></h2>
                                    <DefaultButton small fitWidth clickEvent={() => setIsModalShow(true)}>프렌차이즈 검색</DefaultButton>
                                </Style.FranchiseTitle>
                                <Style.FranchiseInfoDiv>
                                    <p>프렌차이즈 : <span>{franchiseData?.franchise_name}</span></p>
                                    <p>대표 연락처 : <span>{franchiseData?.franchise_contact}</span></p>
                                    <p>매니저 : <span>{franchiseData?.name}</span></p>
                                </Style.FranchiseInfoDiv>
                            </Style.FranchiseDiv>
                        }

                        <DefaultInput label="아이디" inputRef={idRef} placeholder="20글자 이하" />
                        <Style.PasswordContainer>
                            <DefaultInput label="비밀번호" type={isPwShow ? "text" : "password"} inputRef={pwRef} placeholder="비밀번호를 입력해주세요">
                                <button onClick={() => setIsPwShow(state => !state)}>
                                    <img src={isPwShow ? pwShow : pwHide} />
                                </button>
                            </DefaultInput>
                            <Style.PasswordGuide>• 6자 이상, 20자 이하</Style.PasswordGuide>
                            <Style.PasswordGuide>• 영문, 숫자, 특수문자를 모두 포함</Style.PasswordGuide>
                        </Style.PasswordContainer>
                        <DefaultInput label="이름" inputRef={nameRef} placeholder="20글자 이하 | 한글과 영문만 가능" />
                        <DefaultInput label="연락처" inputRef={contactRef} placeholder="'-' 없이 숫자만 입력">
                            <DefaultButton small fitWidth clickEvent={sendEvent} deactive={confirmCookie}>인증번호 받기</DefaultButton>
                        </DefaultInput>
                        {sendState &&
                            <div>
                                <DefaultInput label="인증번호" inputRef={confirmRef} placeholder="6글자의 숫자만 입력">
                                    <DefaultButton small fitWidth clickEvent={confirmEvent} deactive={confirmCookie}>인증하기</DefaultButton>
                                </DefaultInput>
                                {confirmCookie && <Style.Guide>인증되었습니다.</Style.Guide>}
                            </div>
                        }
                    </Style.FormDiv>

                    <Style.BtnDiv>
                        <DefaultButton clickEvent={postAdmin}>회원가입</DefaultButton>
                    </Style.BtnDiv>

                </Style.ContentDiv>
            </Style.Wrapper>
        </>
    )
}

export default SignupManager